import { useZustandLocation } from "@faire/retailer/app/_lib/routing/useZustandLocation";
import { isFromDiscoverURL } from "@faire/retailer/paths";

export const useSearchPageIsFromDiscoverURL = () => {
  const location = useZustandLocation((state) => state.pathname);
  return isFromDiscoverURL(location.pathname);
};
